/**
 *
 * RenderPopconfirm
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Popconfirm } from 'antd';

function RenderPopconfirm({
  showPopup,
  placement,
  message,
  title,
  okText,
  cancelText,
  // actions
  onCancel,
  onConfirm,
  // default props
  className,
  children,
}) {
  const childClassNames = classNames(
    'render-tab-title-wrapper',
    'popconfirm-window',
    className,
  );
  const [t, i18n] = useTranslation();

  const defaultMessage = t("common.renderPopconfirmMessage");
  const defaultOK = t("common.yes");
  const defaultCancel = t("common.no");

  return showPopup ? (
    <Popconfirm
      placement={placement}
      title={!!message && message || defaultMessage}
      onCancel={onCancel}
      onConfirm={onConfirm}
      okText={!!okText && okText || defaultOK}
      cancelText={!!cancelText && cancelText || defaultCancel}
      overlayClassName={childClassNames}
    >
      {title || children}
    </Popconfirm>
  ) : (
    title || children
  );
}

RenderPopconfirm.defaultProps = {
  placement: 'top',
  showPopup: false,
};
RenderPopconfirm.propTypes = {
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

export default memo(RenderPopconfirm);
